// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner-container[data-v-e5ea64de]{margin:0 auto;position:relative}.banner-container[data-v-e5ea64de],.banner-container img[data-v-e5ea64de]{width:calc(var(--inner-width)*1px)}.cover[data-v-e5ea64de]{display:none}", ""]);
// Exports
module.exports = exports;
